import { ArrowDown, ArrowUp, Minus } from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";

interface MetricBlockProps {
  label: string;
  value: string;
  trend?: "up" | "down" | "neutral";
}

const TrendIcon = ({ trend }: { trend?: string }) => {
  if (trend === "up") return <ArrowUp size={14} className="text-malachite-700" />;
  if (trend === "down") return <ArrowDown size={14} className="text-puntt-red-9" />;
  if (trend === "neutral") return <Minus size={14} className="text-puntt-neutral-gray-9" />;
  return null;
};

const TREND_BAR_COLOR: Record<string, string> = {
  up: "bg-malachite-600",
  down: "bg-puntt-red-9",
  neutral: "bg-puntt-neutral-gray-7",
};

export function MetricBlock({ label, value, trend }: MetricBlockProps) {
  return (
    <div className="rounded-xl border border-puntt-neutral-gray-5 bg-base-white p-4 shadow-sm transition-all duration-200 hover:border-puntt-accent-7 hover:shadow-md">
      {trend && (
        <div className={`mb-2 h-0.5 w-8 rounded-full ${TREND_BAR_COLOR[trend] ?? TREND_BAR_COLOR.neutral}`} />
      )}
      <Text as="p" size="1" className="text-puntt-neutral-gray-9">
        {label}
      </Text>
      <div className="mt-1 flex items-center gap-1.5">
        <Text size="6" weight="bold" className="text-puntt-neutral-gray-12">
          {value}
        </Text>
        <TrendIcon trend={trend} />
      </div>
    </div>
  );
}
